import _ from 'lodash';
import type { ApolloCache } from '@apollo/client';
import updateApolloList from './updateApolloList';

export default function updateQueryList<
  Cache,
  Response extends { data?: Data | null },
  Data extends { [key in NewItemKey]?: NewItem | null },
  NewItemKey extends string,
  NewItem extends Item,
  Item extends { id?: string | null } | object | string,
>(
  params: Parameters<ApolloCache<Cache>['readQuery']>[0],
  listPath: string | string[],
  newItemKey: NewItemKey,
  add = true,
) {
  return (proxy: ApolloCache<Cache>, { data }: Response) => {
    try {
      if (!data) return;
      const prev = proxy.readQuery(params) as object;
      if (!prev) return;

      const next = _.castArray(listPath).reduce(
        (updated, path) =>
          updateApolloList(updated, data, path, newItemKey, add),
        prev,
      );
      proxy.writeQuery({ ...params, data: next });
    } catch (e) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn(e);
      }
    }
  };
}
